import { $sxhr } from "../../stempcore";
import { sxhr } from "fire-wind-water/sxhr";
import { from, of } from "rxjs";
import { mergeMap } from "rxjs/operators";

const cacheWithParams = {
  _cache_with_cached: 0,
  _cache_refresh: 0,
  _cache_timeout: 5 * 60
};

// 封装静态化请求
const staticRequest = function(url, info, conf) {
  // 存在静态化配置，优先获取静态连接，如不存在，走API请求
  var staticUrl = window.staticReqMapping
    ? window.staticReqMapping.getStaticUrl(url, info)
    : "";
  const params = { ...info, ...cacheWithParams };
  if (staticUrl) {
    return from(
      // 利用from操作符将Promise转为Observable
      // 请求静态地址(url上需要添加随机数，以保证数据为最新)
      sxhr
        .get(staticUrl + "?time_stamp=" + new Date().getTime(), info, conf)
        .then(
          res => {
            return res.data.body;
          },
          () => {
            return null; // 静态json错误，返回null
          }
        )
    ).pipe(
      mergeMap(body => {
        if (body) {
          return of(body);
        } else {
          // 静态json出错，转为API请求
          return $sxhr.post(url, params, conf);
        }
      })
    );
  } else {
    return $sxhr.post(url, params, conf);
  }
};

export default {
  install: function(Vue) {
    Vue.prototype.service = {
      //获取互动参数
      getTenantPerm: info => {
        return $sxhr.post("api/webinar/GetTenantPermList", info);
      },
      //获取会议信息
      getMeeting: info => {
        // return $sxhr.post("api/webinar/get", info);
        return staticRequest("api/webinar/get", info);
      },
      // 获取模板配置信息
      getTemplateConfig: info => {
        const params = { ...info, ...cacheWithParams };
        // return $sxhr.post("template/template/getConfig", params);
        return staticRequest("template/template/getConfig", params);
      },
      //获取文件列表
      getResource: info => {
        // return $sxhr.post("file/getList", info);
        return staticRequest("file/getList", info);
      }, //获取中奖结果
      getLotteryRecord: info => {
        return $sxhr.post("webinar/open/getLuckyDrawRoster", info);
      }, //获取参会人信息
      getContacts: info => {
        return $sxhr.post("api/webinar/contacts/get", info);
      }, //检查是否报名
      checkRegistration: info => {
        return $sxhr.post("webinar/open/checkRegistration", info);
      }, //静默报名
      silentSignUp: info => {
        return $sxhr.post("api/webinar/contacts/signup", info);
      }, //获取服务器时间
      getServerTime: info => {
        return $sxhr.post("webinar/open/getServerTime", info);
      }, //检查session是否过期
      checkSess: info => {
        return $sxhr.post("anonymous/checkSess", info);
      },
      //获取自定义表单(报名表单)的地址
      getCustomForm: info => {
        return $sxhr.post("customForm/get", info);
      },
      //获取海报分享地址
      getPosterShareUrl: info => {
        return $sxhr.post("template/platform/instance/getUrl", info);
      },
      getPosterStatus: info => {
        return $sxhr.post("template/platform/instance/getStatus", info);
      },
      //获取视频回放列表
      getVideoPlayback: info => {
        // return staticRequest("api/webinar/replay/getList", info);
        return staticRequest("api/webinar/replay/getList", info);
      },
      //视频增加播放次数
      postVideoIncTimes: info => {
        return staticRequest("api/webinar/demand/record", info);
      }
    };
  }
};
export { staticRequest };
